define(function(require) {
  const Marionette = require('backbone.marionette');
  const tpl = require('civicsViews/problems/templates/t_itv_problem_item.hbs');
  return Marionette.ItemView.extend({
    initialize: function(options) {
      this.config = options.config;
    },
    template: tpl,
    tagName: 'div',
    className: function() {
      return 'list-row';
    },
    attributes: {
      'role': 'row'
    },
    templateHelpers:function() {
      var self = this;
      var helpers = {
        showComments: function() {
          return !self.config.isPublic;
        },
        showPageReference: function()
        {
          var profile = (self.config.isPublic) ? 'public' : (self.config.isCustomer) ? 'customer' : (self.config.isProvider) ? 'provider' : '';
          var electronicPlanConfig = self.config.globalConfig.electronicPlanAttributes;

          return (self.model.has('pageReference') && electronicPlanConfig != undefined && electronicPlanConfig.hasOwnProperty(profile) && 
                electronicPlanConfig[profile].indexOf('PageReference') != '-1');
        },
        displayLink: (self.model.has('ElectronicPlanReviewProblemUrl') && self.config.isProvider),
      };
      return helpers;
    }
  });
});
